export default __webpack_public_path__ + "static/media/reminder-message.06746265.svg";